import Button from 'common/components/button'
import { ArrowLeft as ArrowLeftIcon } from 'common/icons'

import { useExperimentForm } from './context/ExperimentFormContext'

const SetUpExperimentBar = () => {
  const {
    dispatch,
    state: { isExperimentFormVisible },
  } = useExperimentForm()

  return (
    <div className="flex justify-between my-2 p-6 w-full">
      <Button
        ghost={true}
        onClick={() => {
          dispatch({
            type: 'set_experiment_form_visible',
            value: !isExperimentFormVisible,
          })
        }}
      >
        <ArrowLeftIcon size={4} />
      </Button>
      <Button ghost={true} onClick={() => {}}>
        Done
      </Button>
    </div>
  )
}

export default SetUpExperimentBar
